import faker from 'faker';
import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import { formatDistance } from 'date-fns';
import { Link as RouterLink } from 'react-router-dom';
import arrowIosForwardFill from '@iconify/icons-eva/arrow-ios-forward-fill';
// material
import {
  Box,
  Stack,
  Link,
  Card,
  Button,
  Divider,
  Typography,
  CardHeader,
  colors
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
// utils
import { mockImgCover } from '../../../utils/mockImages';
//
import Scrollbar from '../../Scrollbar';

// ----------------------------------------------------------------------

RequestSPLPService.propTypes = {
  item: PropTypes.object.isRequired,
  handleClick: PropTypes.func.isRequired,
  selectedService: PropTypes.object.isRequired
};

export default function RequestSPLPService({ selectedService, item, handleClick }) {
  const theme = useTheme();
  return (
    <Card sx={{ maxWidth: 250 }}>
      <CardHeader
        title={item?.name}
        style={
          selectedService.id === item.id
            ? { color: theme.palette.primary.main }
            : { color: '#424242' }
        }
      />

      <Box>
        <Stack direction="column" spacing={1} sx={{ p: 3, pr: 0, minHeight: 170 }}>
          {item?.methods?.map((information) => (
            <Typography variant="body2" style={{ padding: 1 }}>
              Methods : {information}
            </Typography>
          ))}
          {item?.tags?.map((information) => (
            <Typography variant="body2" style={{ padding: 1 }}>
              Tags : {information}
            </Typography>
          ))}
        </Stack>
      </Box>

      <Divider p={2} />

      <Box
        sx={{
          p: 2,
          textAlign: 'center',
          bgcolor: selectedService.id === item.id ? 'primary.main' : 'background.neutral'
        }}
      >
        <Button
          disabled={item.status === 'inactive'}
          size="small"
          color="inherit"
          sx={{ color: selectedService.id === item.id ? 'white' : 'primary.main' }}
          onClick={() => handleClick(item)}
        >
          {selectedService.id === item.id ? 'Batal' : 'Pilih'}
        </Button>
      </Box>
    </Card>
  );
}
